var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    fillRule: "evenodd",
    d: "M13.47 2.804a.75.75 0 0 0 0 1.06l1.386 1.387H8a6.083 6.083 0 0 0 0 12.166h5.333a.75.75 0 1 0 0-1.5H8a4.583 4.583 0 1 1 0-9.166h6.856L13.47 8.137a.75.75 0 0 0 1.06 1.06l2.667-2.666a.75.75 0 0 0 0-1.06L14.53 2.803a.75.75 0 0 0-1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgRedo;